/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const LoyaltyRedemptionStatus = {
    _11184809: '11184809',
    ERROR: 'ERROR',
    PENDING: 'PENDING',
    COMPLETE: 'COMPLETE',
    unknown_default_open_api: '11184809'
} as const;
export type LoyaltyRedemptionStatus = typeof LoyaltyRedemptionStatus[keyof typeof LoyaltyRedemptionStatus];


export function instanceOfLoyaltyRedemptionStatus(value: any): boolean {
    for (const key in LoyaltyRedemptionStatus) {
        if (Object.prototype.hasOwnProperty.call(LoyaltyRedemptionStatus, key)) {
            if (LoyaltyRedemptionStatus[key as keyof typeof LoyaltyRedemptionStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function LoyaltyRedemptionStatusFromJSON(json: any): LoyaltyRedemptionStatus {
    return LoyaltyRedemptionStatusFromJSONTyped(json, false);
}

export function LoyaltyRedemptionStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoyaltyRedemptionStatus {
    return json as LoyaltyRedemptionStatus;
}

export function LoyaltyRedemptionStatusToJSON(value?: LoyaltyRedemptionStatus | null): any {
    return value as any;
}

